import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ImpersonationBanner from './ImpersonationBanner';

const ImpersonationBannerWrapper = () => {
  const { isImpersonating, user, realUser, stopImpersonation } = useAuth();
  const [stopping, setStopping] = useState(false);

  if (!isImpersonating) return null;

  const handleStop = async () => {
    setStopping(true);
    await stopImpersonation();
    setStopping(false);
    // Reload to refresh all page data with admin's permissions
    window.location.reload();
  };

  return (
    <ImpersonationBanner
      impersonatedUser={user}
      realUser={realUser}
      onStop={handleStop}
      loading={stopping}
    />
  );
};

export default ImpersonationBannerWrapper;
